import React, { useContext, useState } from 'react';
import { styled, InputAdornment } from '@material-ui/core';

import { SdmTextField, SdmTypography } from 'components';
import { theme } from 'theme';
import { useDataHelper } from 'utils/dataHelper';
import { AuthContext } from 'context/AuthContextProvider';

import 'emoji-mart/css/emoji-mart.css';

const ChatSdmTextField = styled(SdmTextField)(({ ismobile }) => ({
  backgroundColor: 'transparent',
  borderBottom: `1px solid black`,
  borderRadius: 0,
  paddingBottom: 13,
  '& ::-webkit-input-placeholder': {
    /* Chrome/Opera/Safari */ color: 'black',
    opacity: 1,
    fontFamily: 'Suisse-Intl',
    fontSize: ismobile ? '1rem' : 24,
  },
  '& .MuiInput-input': {
    input: {
      '&::placeholder': {
        color: 'black',
      },
    },
    color: theme.colors.primary.black,
    fontSize: ismobile ? '1rem' : '1.250rem',
    fontFamily: 'Suisse-Intl',
    ...(ismobile && {
      marginBottom: '0px !important',
    }),
  },
}));

const MessageInputContainer = styled('div')(({ ismobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  paddingBottom: ismobile ? 0 : 40,
}));

const formControlStyle = { width: 'calc(100%)' };

export const MessageInput = ({
  i18n,
  publish,
  scrollChatToBottom,
  isVip,
  isXsDown,
  hasScrolled,
  isMenuOpen,
}) => {
  const { user } = useContext(AuthContext);
  const { extractUserInfo } = useDataHelper();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  const onMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const onSendMessage = () => {
    if (message && message.trim()) {
      setError(false);
      publish(
        {
          type: 'chat',
          text: message,
          userInfo: extractUserInfo({ ...user, isVip: isVip }),
        },
        (res) => {
          setError(res.status.error);
          if (!res.status.error) {
            setMessage('');
            scrollChatToBottom();
          }
        }
      );
    }
  };

  const handleKeyDown = (e) => {
    e.key === 'Enter' && onSendMessage();
  };

  return (
    <MessageInputContainer ismobile={isXsDown ? 1 : 0}>
      {hasScrolled && (
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(245,245,245,0) 0%, rgba(245,245,245,0.5) 31.25%, #F5F5F5 100%)',
            zIndex: isMenuOpen ? 0 : 10,
            height: 115,
            width: '100%',
            position: 'absolute',
            bottom: 'calc(100% - 1px)',
          }}
        ></div>
      )}
      <ChatSdmTextField
        error={error}
        helperText={error ? i18n.error.label : null}
        formControlStyle={formControlStyle}
        value={message}
        onChange={onMessageChange}
        onKeyDown={handleKeyDown}
        placeholder={i18n.placeholder}
        inputPropsStyle={{ marginTop: 0 }}
        ismobile={isXsDown ? 1 : 0}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SdmTypography
                onClick={onSendMessage}
                variant="h2"
                margin={0}
                style={{ color: 'black', cursor: 'pointer' }}
              >
                {i18n.send.label}
              </SdmTypography>
            </InputAdornment>
          ),
        }}
      />
    </MessageInputContainer>
  );
};
